module.exports = __webpack_public_path__ + "media/images/favicon1021x1021-07438d4524d688a965da12e2c880ab7c.png";